import React from "react";
import {ListItem, SectionHeading} from "../PromotionsText";

const HoleInOneSection = () => (
  <>
    <SectionHeading>HOLE-IN-ONE</SectionHeading>

    <ListItem marker="(a)">
      {"The Hole-in-One Payouts may be adjusted or eliminated at any time. Please check your app and on screen to see the qualifying payout for Hole-in-One when playing."}
    </ListItem>

    <ListItem marker="(b)">
      {"The Hole-in-One Payout is subject to video reviewal by Evenplay representatives."}
    </ListItem>

    <ListItem marker="(c)">
      {"The Hole-in-One Payout may NOT be credited to the player’s wallet. Instead after verification, the player will receive their Hole-in-One Payout at an event as detailed in Section 17(d) below."}
    </ListItem>

    <ListItem marker="(d)" withBottomMargin>
      {"In order to receive the Hole-in-One payout, player agrees to attend an event wherein Evenplay and venue representatives will hand over payment (cash, check or other legal tender). This event may include photography and video. Player is required to give testimonials during the event."}
    </ListItem>
  </>
);

export default HoleInOneSection;
